import { replace, trim } from "lodash";

export const toUpperCase = str => {
  if (str === undefined) {
    return "";
  }
  const arr = str.split(" ");
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr.join(" ");
  return str2;
};

export const parsePhoneNumber = str => {
  const phoneNumberRegex =
    /^\s*(?:\w*?:)?\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/gi;
  return str.match(phoneNumberRegex);
};

/**
 * Replaces all occurrences of a substring in a string with a specified replacement
 * Uses lodash's replace function for optimal performance
 * @param {string} str - The original string
 * @param {string} substring - The substring to be replaced
 * @param {string} replacement - The string to replace the substring with
 * @returns {string} - The formatted string with replacements
 */
export const replaceSubstring = (str, substring, replacement) => {
  if (!str || typeof str !== "string") {
    return "";
  }

  if (!substring || typeof substring !== "string") {
    return str;
  }

  // Using lodash's replace function which handles global replacement
  return replace(str, new RegExp(substring, "g"), replacement || "");
};

/**
 * Prepends a prefix to the input string only if it doesn't already start with it (case-insensitive).
 *
 * @param {string} input - The original string (e.g., email subject).
 * @param {string} prefix - The prefix to prepend (e.g., "Re:", "Fwd:").
 * @returns {string} - Resulting string with the prefix.
 */
export const smartPrepend = (input, prefix) => {
  const trimmed = trim(input || "");
  const regex = new RegExp(`^${prefix}`, "i");
  return regex.test(trimmed) ? trimmed : `${prefix} ${trimmed}`;
};
